import styled from "@emotion/styled";

import { Form } from "@skilitics/designer-ui-components";

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;

  height: 100%;
  max-width: var(--dialog-width);

  padding: 0;
`;

export const Section = styled.div`
  margin-bottom: 15px;
`;
